import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-primary to-secondary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <i className="ri-heart-pulse-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">عيادة الإقلاع</h3>
                <p className="text-sm text-white/80">جمعية مكافحة التدخين</p>
              </div>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              نساعدك على الإقلاع بأمان من خلال خدمات طبية مجانية ومعتمدة
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-bold mb-4">تواصل معنا</h4>
            <div className="space-y-3">
              <a href="tel:+966500000000" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <span>+966 50 000 0000</span>
              </a>
              <a href="mailto:info@quit-clinic.sa" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <span>info@quit-clinic.sa</span>
              </a>
              <div className="flex items-start gap-3 text-white/90">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <span>الأفلاج، المملكة العربية السعودية</span>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-bold mb-4">خريطة الموقع</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  من نحن
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  خدماتنا
                </Link>
              </li>
              <li>
                <Link to="/consultation" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  طلب استشارة
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  تواصل معنا
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-bold mb-4">تابعنا</h4>
            <div className="flex gap-3">
              <a
                href="https://wa.me/966500000000"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
            <a
              href="https://wa.me/966500000000"
              className="inline-flex items-center gap-2 bg-white text-primary px-6 py-3 rounded-lg font-medium hover:bg-white/90 transition-all duration-300 shadow-lg mt-4 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>تواصل عبر واتساب</span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/80">
            <p>جميع الحقوق محفوظة © {currentYear} عيادة الإقلاع</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};